module.exports = __webpack_public_path__ + "img/1746687821807-WhatsApp Image 2025-05-08 at 15.01.45.jpeg.2f2f297b.webp";